import React, { Component } from "react";
import { get } from "lodash";
import { withCars } from "../../../../shared/containers/containerCars";
import { withFilterCars } from "../../../../shared/containers/containerFilterCars";
import { states } from "../../../../reducers/queriesStates";
import Preloader from "../../../../shared/items/static/preloader";
import Notification from "../../../../shared/items/static/notification";
import styles from "./driverUnitsBar.module.scss";
import DriverUnitListItems from "./DriverUnitListItems";
import { unitFilterService } from "../../../sections/cars/unitFilterService";
import { withAuth } from "../../../../shared/containers/containerAuth";
import { withWinter } from "../../../../shared/containers/containerWinter";

class DriverUnitList extends Component {
  componentDidMount() {
    unitFilterService.didMount(this.props);
  }

  componentDidUpdate(prevProps) {
    unitFilterService.didUpdate(prevProps, this.props);
  }

  render() {
    const { handleScrollTo, listUnits, dataStateUnits } = this.props;

    if (dataStateUnits === states.REQUEST) {
      return (
        <React.Fragment>
          <div className={styles.userUnitsList_wrapper}>
            <div className={styles.container_preloader}>
              <Preloader />
            </div>
          </div>
        </React.Fragment>
      );
    }

    if (listUnits.length === 0) {
      return (
        <React.Fragment>
          <div className={styles.userUnitsList_wrapper}>
            <Notification type="warning">
              <p>По данным параметрам поиска автомобили не найдены.</p>
            </Notification>
          </div>
        </React.Fragment>
      );
    }

    return (
      <React.Fragment>
        <div className={styles.userUnitsList_wrapper}>
          <div className={styles.userUnitsList}>
            <DriverUnitListItems data={listUnits} handleScrollTo={handleScrollTo} />
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default withWinter(withAuth(withCars(withFilterCars(DriverUnitList))));
